import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {
  BASE_URL,
  DEFAULT_HEADERS,
} from './api-constants';

import {
  OrderResponse,
  MMRPResponse,
  orderRequest,
  MMRPRequest,
  AddProductRequest,
  DeleteItemRequest,
  ApplyCouponRequest,
  InvoiceRequest,
  InvoiceResponse,
  VerifyPaymentRequest,
  PaymentStatus,
  CheckStatusResponse,
  AddBagRequest,
  AddFreebieRequest,
  EliteRequest,
  TxnTokenResponse,
  PromosRequest,
} from '../lib/order-types';
import axios from 'axios';
import {logout} from '../core/utils/routing.util';
//import {setAccessToken} from '../core/localstorage-data'

//TODO: - write the API calls here
const _api_url_getorder = `${BASE_URL}/order`;
const _api_url_checkmmrp = `${BASE_URL}/order/check-mmrp`;
const _api_url_addproduct = `${BASE_URL}/order/add`;
const _api_url_removeitem = `${BASE_URL}/order/remove`;
const _api_url_applycoupon = `${BASE_URL}/order/apply-coupon`;
const _api_url_generateinvoice = `${BASE_URL}/order/generate-invoice`;
const _api_url_verifypayment = `${BASE_URL}/order/verify-payment`;
const _api_url_checkstatus = `${BASE_URL}/order/check-status`;
const _api_url_allorders = `${BASE_URL}/order/all`;
const _api_url_addbag = `${BASE_URL}/order/add-bag`;
const _api_url_removebag = `${BASE_URL}/order/remove-bag`;
const _api_url_getfreebies = `${BASE_URL}/order/get-freebies`;
const _api_url_addfreebie = `${BASE_URL}/order/add-freebie`;
const _api_url_removefreebie = `${BASE_URL}/order/remove-freebie`;
const _api_url_removecoupon = `${BASE_URL}/order/remove-coupon`;
const _api_url_elitemembership = `${BASE_URL}/order/membership-subscription`;
const _api_url_requesttxntoken = `${BASE_URL}/order/request-payment-token`;
const _api_url_fetchpromos = `${BASE_URL}/order/get-promos`;

export const getOrderId = async (
  parameters: orderRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_getorder}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );

    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const checkMMRPApi = async (
  parameters: MMRPRequest,
): Promise<MMRPResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_checkmmrp}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );

    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const addProductApi = async (
  parameters: AddProductRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_addproduct}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const deleteItemApi = async (
  parameters: DeleteItemRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_removeitem}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const applyCouponApi = async (
  parameters: ApplyCouponRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_applycoupon}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const removeCouponApi = async (
  parameters: InvoiceRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_removecoupon}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const addBagApi = async (
  parameters: AddBagRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_addbag}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const removeBagApi = async (
  parameters: AddBagRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_removebag}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const requestTxnTokenApi = async (
  parameters: InvoiceRequest,
): Promise<TxnTokenResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_requesttxntoken}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const verifyPaymentApi = async (
  parameters: VerifyPaymentRequest,
): Promise<PaymentStatus> => {
  try {
    const response = await httpClient.post(
      `${_api_url_verifypayment}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const generateReadyToInvoice = async (
  parameters: InvoiceRequest,
): Promise<InvoiceResponse> => {


  try {
    const response = await axios.post(
      `${_api_url_generateinvoice}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );

    {
      
      return response.data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    // throw new APIError(error);
    //return n error;
    if (error.response.status === 401 || error.response.status === 403) {
      logout();
    }
    throw error;
  }
};
export const checkTransactionStatusApi = async (
  parameters: InvoiceRequest,
): Promise<CheckStatusResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_checkstatus}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};

export const fetchAllOrdersApi = async (
  accessToken: string,
): Promise<OrderResponse[]> => {
  try {
    const response = await httpClient.get(`${_api_url_allorders}`, {
      headers: {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const fetchFreebiesApi = async (
  parameters: InvoiceRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_getfreebies}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const addFreebieApi = async (
  parameters: AddFreebieRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_addfreebie}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const removeFreebieApi = async (
  parameters: InvoiceRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_removefreebie}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const eliteMembershipSubscriptionApi = async (
  parameters: EliteRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_elitemembership}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const fetchPromosApi = async (
  parameters: PromosRequest,
): Promise<OrderResponse> => {
  try {
    const response = await httpClient.post(
      `${_api_url_fetchpromos}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
